const authCodes = {
  INVALID_EMAIL: 'auth/invalid-email',
  USER_NOT_FOUND: 'auth/user-not-found',
  WRONG_PASSWORD: 'auth/wrong-password',
  WEAK_PASSWORD: 'auth/weak-password',
};


export const authFlowEvents = {
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_FAILURE: 'LOGIN_FAILURE',
  RECAPTCHA_COMPLETED: 'RECAPTCHA_COMPLETED',
  RECAPTCHA_FAILED: 'RECAPTCHA_FAILED',
  MFA_START_SUCCESS: 'MFA_START_SUCCESS',
  MFA_START_FAILURE: 'MFA_START_FAILURE',
  OTP_INVALID: 'OTP_INVALID',
  MFA_FINALIZE_SUCCESS: 'MFA_FINALIZE_SUCCESS',
  MFA_FINALIZE_FAILURE: 'MFA_FINALIZE_FAILURE',
  RECAPTCHA_CHALLENGE_COUNT: 'RECAPTCHA_CHALLENGE_COUNT',
};

export const loginFailureReason = {
  TOO_MANY_REQUESTS: 'Too many requests',
  WRONG_CREDENTIALS: "Wrong email or password",
  TWO_FACTOR_ERROR: "Two factor error",
  TWO_FACTOR_WRONG_CODE:"Two factor wrong code",
  NOT_FOUND: "User not found"
}

export default authCodes;
